import z from 'zod';
import { Paths } from 'type-fest';

import {
  OfferNameAndDescriptionSchema,
  ProductPurchaseSchema,
  SpendBonusSchema,
} from '@occc/validation';

import { BaseEarnOfferSchema } from './schemas/base-earn/base-earn-offer.schema';
import { BaseEarnSchema } from './schemas/base-earn/base-earn.schema';
import { BaseEligibleEarnOfferSchema } from './schemas/base-eligible-earn/base-eligible-earn-offer.schema';
import { BaseEligibleEarnSchema } from './schemas/base-eligible-earn/base-eligible-earn.schema';
import { ExternalFulfillmentOfferSchema } from './schemas/external-fulfillment-offer.schema';
import { ProductPurchaseOfferSchema } from './schemas/product-purchase/product-purchase-offer.schema';
import { SpendBonusOfferSchema } from './schemas/spend-bonus/spend-bonus-offer.schema';
import { DraftConfigurationOfferSchema } from './schemas/draft-configuration-offer.schema';

export enum OfferType {
  ProductPurchase = 'productPurchase',
  SpendBonus = 'spendBonus',
  BaseEarn = 'baseEarn',
  BaseEligibleEarn = 'baseEligibleEarn',
  ExternalFulfillment = 'externalFulfillment',
}

export type BaseEarnFormValues = z.infer<typeof BaseEarnSchema>;
export type BaseEligibleEarnFormValues = z.infer<typeof BaseEligibleEarnSchema>;
export type ProductPurchaseFormValues = z.infer<typeof ProductPurchaseSchema>;
export type SpendBonusFormValues = z.infer<typeof SpendBonusSchema>;

type DraftConfigurationOfferFormValues = z.infer<typeof DraftConfigurationOfferSchema>;
type BaseEarnOfferFormValues = z.infer<typeof BaseEarnOfferSchema>;
type BaseEligibleEarnOfferFormValues = z.infer<typeof BaseEligibleEarnOfferSchema>;
type ProductPurchaseOfferFormValues = z.infer<typeof ProductPurchaseOfferSchema>;
type SpendBonusOfferFormValues = z.infer<typeof SpendBonusOfferSchema>;
type ExternalFulfillmentOfferFormValues = z.infer<typeof ExternalFulfillmentOfferSchema>;

export type ConfigurationFormNameAndDescriptionValues = z.infer<
  typeof OfferNameAndDescriptionSchema
>;

export type CampaignFormValue = {
  uuid: string;
  name: string;
};

export type OfferConfigureFormValues =
  | DraftConfigurationOfferFormValues
  | BaseEarnOfferFormValues
  | BaseEligibleEarnOfferFormValues
  | ProductPurchaseOfferFormValues
  | SpendBonusOfferFormValues
  | ExternalFulfillmentOfferFormValues;

export type OfferConfigureFormInitialValues = Partial<OfferConfigureFormValues>;

export type OfferConfigureFormValuesPaths = Paths<OfferConfigureFormValues>;
